import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Toaster } from "sonner";
import App from "./App";
import "./i18n";
import { installFetchUnauthorizedRedirect } from "./lib/authRedirect";
import { queryClient } from "./lib/queryClient";
import "./styles/index.css";

// Send signed-out users (API 401) to the right login page — see lib/authRedirect.ts.
installFetchUnauthorizedRedirect();

ReactDOM.createRoot(document.getElementById("root")!).render(
  // Disabled React.StrictMode to prevent double-mounting in development
  // which causes unnecessary request cancellations with TanStack Query
  // In production builds, this doesn't matter as Strict Mode is automatically disabled
  // <React.StrictMode>
  <QueryClientProvider client={queryClient}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
    {/* One toaster for the whole SPA (B2B app, moderator panel, public pages). */}
    <Toaster position="top-right" richColors closeButton />
    <ReactQueryDevtools initialIsOpen={false} />
  </QueryClientProvider>,
  // </React.StrictMode>
);
